import { ACTIONS_OPTIONS, FULL_MENU_STATES, ONLY_VIEW_OPTION, PACIFICO_OPTIONS_BASE, VIEW_CANCEL_EDIT_OPTIONS, VIEW_EDIT_OPTIONS } from "@/constants/accessControl";
import { ESTADO_REQUISITO, UPLOADED_IMAGE } from "@/constants/commons";
import { type SegcenFormat } from "@/interfaces/AccessControl";
import { type RequirementMenuOptionsParams } from "./requirements";
import { Rol } from "@/constants/roles";
import { configOptionAction } from "@/routes/gestor-requisitos/-src/constants/requirements";
import { getPermissionEvaluation } from "@/routes/gestor-evaluacion/-src/utils/evaluation";
import { getPermissionDetailEvaluateRelief } from "@/routes/gestor-requisitos/-src/util/requirements";

interface validateSegcenPermissionsProps {
  segcen: SegcenFormat;
  object: string;
  action: string;
};

export const validateSegcenPermissions = ({
  segcen,
  object,
  action,
}: validateSegcenPermissionsProps) => {
  if (!segcen) return false;
  if (!object) return false;
  if (!action) return false;
  if (!Object.prototype.hasOwnProperty.call(segcen, object)) return false;

  return segcen[object].includes(action);
};

export const getMenuOptionsEvaluationToRequirement = (params: Partial<RequirementMenuOptionsParams>) => {
  const {
    requirementStateCode,
    image
  } = params;

  const hasImage = image === UPLOADED_IMAGE.HAS_IMAGE;

  if (requirementStateCode && FULL_MENU_STATES.includes(requirementStateCode))
    return [...VIEW_CANCEL_EDIT_OPTIONS];

  if (requirementStateCode === ESTADO_REQUISITO.PENDIENTE_CANAL)
    return hasImage ? [...VIEW_EDIT_OPTIONS] : [...VIEW_CANCEL_EDIT_OPTIONS];

  if (requirementStateCode === ESTADO_REQUISITO.PENDIENTE_PACIFICO)
    return hasImage ? [...PACIFICO_OPTIONS_BASE] : [...PACIFICO_OPTIONS_BASE, ACTIONS_OPTIONS.annular];

  return [...ONLY_VIEW_OPTION];
}

export const allowActionEvaluate = ({ option, idRole, fullName, evaluationUser }:
  { option: string, idRole: number, fullName: string, evaluationUser: string }) => {
    const config = configOptionAction[option as keyof typeof configOptionAction];
  const onlyEvaluatorAssigned = config?.onlyEvaluatorAssigned;

  let allowAction = false;
  if(idRole === Rol.EVALUATOR)
    allowAction = ((onlyEvaluatorAssigned && evaluationUser.toLowerCase() === fullName.toLowerCase()) || !onlyEvaluatorAssigned)
  
  return allowAction;
}

export const allowActionRequirement = ({ idRole }: { idRole: number }) => {
  return idRole === Rol.EJECUTIVO_DESGRAVAMEN;
}

export const isDisabledButtonBySegcen = ({ codeActionSegcen, roleId, segcen }: { codeActionSegcen: string, roleId: number, segcen: SegcenFormat }) => {
  return roleId === Rol.EVALUATOR ? !getPermissionEvaluation(codeActionSegcen, segcen) : !getPermissionDetailEvaluateRelief(codeActionSegcen, segcen);
}